/*jshint esversion: 6 */

import React from 'react';

const CaBadgeView = (props)=> {
    const { classNamePrepend, badgeImg, badgeName, badgeDescription } = props;

    const wrapperClass            = "Badge "+                       classNamePrepend;
    const imgClass                = "Badge__badgeImg "+             classNamePrepend +"__badgeImg";
    const badgeNameClass          = "Badge__badgeText "+            classNamePrepend +"__badgeText";
    const badgeDescriptionClass   = "Badge__badgeDescription "+     classNamePrepend+"__badgeDescription";

    return(
        <div className={wrapperClass}>
            <div className={""}>
                <img className={imgClass} src={badgeImg} />
            </div>
            <div className={""}>
                <div className={badgeNameClass}>{badgeName}</div>
                <div className={badgeDescriptionClass}>{badgeDescription}</div>
            </div>
        </div>
    )
};

export default CaBadgeView;




